define('collections/calendar/nutrition/entries',[
    'underscore', 'backbone', 'utils',
    // models
    'models/calendar/nutrition/entry'
], function(
    // libs
    _, Backbone, U,
    // model
    MEntry
) {

    var CFoodEntries = Backbone.Collection.extend({
        model: MEntry,
        sort: 'hour',
        initialize: function(models, options) {
            options = _.extend({}, options);

            _.extend(this, {
                hour: options.hour,
                calories: 0
            });
        },

        onNewModel: function(model, options) {
            if (this.hour) {
                model.set({ hour: this.hour }, options);
            }
        },

        getTotalNutrients: function(options) {
            var entries = this.where(options);
            if (!entries.length) return;
            return _.reduce(entries, getEntryNutrients, {});
        },

        getCalories: function() {
            return this.reduce(function(total, entry) {
                return total + (entry.isEaten() ? entry.getCalories() : 0);
            }, 0, this);
        },

        getTotalCalories: function() {
            return this.reduce(function(total, entry) {
                return total + entry.getCalories();
            }, 0, this);
        }

    });

    function getEntryNutrients(nutrientObj, entry) {
        return entry.addNutrientTo(nutrientObj);
    }

    return CFoodEntries;
});

